import ReactDOM from "react-dom";
import React from "react";
import { getAttributes } from "./getAttributes";

/**
 * retrieves attributes from an element and turn them into an object
 * @param el - html element
 * @param prefix
 * @returns boolean
 */

export function mountReact(wrapperSelector, RootComponent) {
  const el = document.querySelector(wrapperSelector);
  if (el) {
    const props = getAttributes(el, "prop-");
    /* disable for production */
    // console.log(JSON.stringify(props))
    ReactDOM.render(<RootComponent {...props} />, el);
    return true;
  } else {
    /* disable for production */
    // console.error(`Unable to find element by selector: ${wrapperSelector}`);
    return false;
  }
}
